import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { NetworkingService } from './../../shared/networking.service';
//import { AgencyList } from '../../shared/agency.model';

@Injectable()
export class DashboardService {

  	constructor(private networkingService: NetworkingService) {}
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/dashboard/shared/dashboard.service.ts